import { useEffect, useState } from 'react';
import { Subscription } from 'rxjs';
import { useGeneralContext } from '../../../../services/GeneralContext';
import './Flowers.scss';

const numberOfFlowers = 20;

interface FlowerDescription {
  color: string;
  leftOffset: number;
  transitionDelay: number;
}

const Flowers: React.FC = () => {
  const [isFlowering, setIsFlowering] = useState<boolean>(false);

  const [flowersData, setFlowersData] = useState<FlowerDescription[]>([]);

  const { easterEggToTrigger$ } = useGeneralContext();

  useEffect(() => {
    const newData: FlowerDescription[] = [];

    Array.from({ length: numberOfFlowers }).forEach((v, i) => {
      let color = '';

      if (i % 4 === 0) {
        color = 'red';
      } else if (i % 3 === 0) {
        color = 'blue';
      } else if (i % 2 === 0) {
        color = 'purple';
      } else if (i % 1 === 0) {
        color = 'yellow';
      }

      const leftOffset = (100 / numberOfFlowers) * i + 2;

      newData.push({
        color,
        leftOffset: leftOffset,
        transitionDelay: Math.floor(Math.random() * 1000)
      });
    });

    setFlowersData(newData);
  }, []);

  useEffect(() => {
    const allSubscriptions = new Subscription();

    allSubscriptions.add(
      easterEggToTrigger$.subscribe((newData) => {
        if (newData === 'flowers') {
          setIsFlowering((v) => !v);
        }
      })
    );

    return () => {
      allSubscriptions.unsubscribe();
    };
  }, [easterEggToTrigger$]);

  return flowersData.length ? (
    <div className={`flowerBed ${isFlowering ? 'isFlowering' : ''}`}>
      {Array.from({ length: numberOfFlowers }).map((v, i) => {
        return (
          <div
            key={i}
            className={`flower ${isFlowering ? 'isFlowering' : ''} ${flowersData[i].color}`}
            style={{ left: flowersData[i].leftOffset + 'vw', transitionDelay: flowersData[i].transitionDelay + 'ms' }}
            onClick={() => {
              setIsFlowering(false);
            }}
          >
            <div className="stem"></div>

            <div className="buds">
              {Array.from({ length: 9 }).map((_, i2) => {
                return <div key={i2} className={`bud bud${i2}`}></div>;
              })}
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <></>
  );
};

export default Flowers;
